module.exports = __webpack_public_path__ + "img/profile.033793b8.svg";